<template>
  <div>
    <ImportExcel
      :isFlag="isImport"
      :interfaceName="interfaceName"
      :paramsObj="{}"
      paramsKey="excle_path"
      temName="doctor_phone"
      @refreshList="getPhoneData"
    ></ImportExcel>
    <AddGoods
      :isFlag="isAddgoods"
      :imgList="imgList"
      @emitMore="getGoods"
    ></AddGoods>

    <div class="page_title flex_between">
      <span>{{ pageTitle }}</span>
      <el-button type="primary" style="width: 120px" size="medium" @click="back"
        >返回</el-button
      >
    </div>

    <div style="padding: 20px">
      <div class="container">
        <el-form
          :model="info"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
        >
          <div class="title">基本信息</div>
          <el-form-item label="活动名称" prop="act_name">
            <el-input
              v-model="info.act_name"
              maxlength="20"
              style="width: 420px"
              placeholder="不超过20个字"
              :disabled="disabledType == 3"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动备注">
            <el-input
              v-model="info.remark"
              maxlength="20"
              style="width: 420px"
              placeholder="不超过20个字"
              :disabled="disabledType == 3"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间" prop="act_time">
            <el-date-picker
              :clearable="false"
              style="width: 420px"
              v-model="info.act_time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :disabled="disabledType == 2 || disabledType == 3"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="活动链接"
            prop="act_url"
            style="margin-top: 30px"
          >
            <el-input
              v-model="info.act_url"
              style="width: 420px"
              placeholder="请输入活动链接"
              :disabled="disabledType == 3"
            ></el-input>
            <span style="color: #999; font-size: 12px; margin-left: 10px"
              >用于医生端展示活动的页面URL，每次活动需单独定制</span
            >
          </el-form-item>
          <el-form-item
            label="活动参与医生"
            prop="doctor_auth"
            style="margin-top: -10px"
          >
            <el-radio-group
              v-model="info.doctor_auth"
              :disabled="disabledType == 3"
            >
              <el-radio
                :label="1"
                :disabled="
                  disabledType == 2 &&
                  (info.doctor_auth == 2 || info.doctor_auth == 3)
                "
                >全部</el-radio
              >
              <el-radio
                :label="2"
                :disabled="
                  disabledType == 2 &&
                  (info.doctor_auth == 1 || info.doctor_auth == 3)
                "
                >部分参与</el-radio
              >
              <el-radio
                :label="3"
                :disabled="
                  disabledType == 2 &&
                  (info.doctor_auth == 1 || info.doctor_auth == 2)
                "
                >部分不参与</el-radio
              >
            </el-radio-group>
            <el-button
              v-if="info.doctor_auth === 2 || info.doctor_auth === 3"
              type="primary"
              size="mini"
              style="margin-left: 10px"
              @click="addPhoneData"
              :disabled="
                disabledType == 3 &&
                (module_id_array[0] ? !module_id_array.includes('1079') : false)
              "
              >导入手机号</el-button
            >
          </el-form-item>
          <el-form-item
            v-if="info.doctor_auth === 2 || info.doctor_auth === 3"
            style="padding-right: 20px; margin-top: -20px; margin-bottom: 120px"
          >
            <div style="margin: -15px 0 -6px 0">
              已选择{{ doctor_length }}位医生{{
                `${info.doctor_auth === 2 ? "" : "不"}参与`
              }}
            </div>
            <el-input
              type="textarea"
              v-model="info.doctor_string"
              :rows="6"
              placeholder="请填写指定医生手机号，多个用英文逗号隔开"
              onkeyup="this.value=this.value.replace(/[ ]/g,'')"
              @keydown.enter.native="handleTextareaKeydown"
              :disabled="disabledType == 3"
            >
            </el-input>
          </el-form-item>

          <div style="margin-bottom: 20px">
            <span class="title">奖励信息</span>
            <el-button
              type="primary"
              size="medium"
              style="margin-left: 20px"
              @click="addItem"
              :disabled="disabledType == 3"
              >添加奖励节点</el-button
            >
          </div>
          <div>
            <div
              v-for="(item, index) in priceList"
              :key="index"
              class="list_item"
            >
              <div class="flex_between">
                <div>
                  <div>
                    <span class="item_title">奖励名称</span>
                    <el-input
                      v-model="item.rule_name"
                      style="width: 200px"
                      maxlength="10"
                      placeholder="不超过十个字"
                      :disabled="disabledType == 3"
                    >
                    </el-input>
                  </div>
                  <div style="margin: 14px 0">
                    <span class="item_title">门槛条件</span>
                    <span>开方药费总金额达到</span>
                    <el-input-number
                      v-model="item.total_drug_price"
                      :min="0"
                      :max="999999"
                      :precision="2"
                      :controls="false"
                      style="width: 120px; margin: 0 5px"
                      size="medium"
                      placeholder="请输入数字"
                      :disabled="item.disabled || disabledType == 3"
                    ></el-input-number>
                    <span>元</span>
                  </div>
                  <div style="margin: 14px 0">
                    <span class="item_title">奖励类型</span>
                    <span>仁心值奖励比例</span>
                    <el-input-number
                      v-model="item.heart_multiple"
                      :min="0"
                      :max="999999"
                      :precision="1"
                      :controls="false"
                      style="width: 120px; margin: 0 5px"
                      size="medium"
                      placeholder="请输入数字"
                      :disabled="item.disabled || disabledType == 3"
                    ></el-input-number>
                  </div>
                  <div style="margin: 14px 0">
                    <span class="item_title">首次进阶奖励</span>
                    <el-input-number
                      v-model="item.heart_num"
                      :min="0"
                      :max="999999"
                      :precision="0"
                      :controls="false"
                      style="width: 120px; margin: 0 5px"
                      size="medium"
                      placeholder="请输入数字"
                      :disabled="item.disabled || disabledType == 3"
                    ></el-input-number>
                    <span>仁心值</span>
                  </div>
                  <div style="margin: 14px 0">
                    <span class="item_title">礼品兑换专区</span>

                    <el-select
                      v-model="item.jd_access_key"
                      :disabled="item.disabled || disabledType == 3"
                      @change="changeJdKey(item)"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in jd_options"
                        :key="index"
                        :label="item.jd_name"
                        :value="item.jd_access_key"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <span class="item_title">奖励商品展示</span>
                    <!-- :disabled="item.disabled" -->
                    <el-button
                      v-if="disabledType != 3"
                      type="primary"
                      size="mini"
                      style="margin-left: 5px"
                      @click="addGoodsDia('priceList', index, item)"
                      >添加/编辑物品</el-button
                    >
                    <el-button
                      v-else
                      type="primary"
                      size="mini"
                      style="margin-left: 5px"
                      @click="addGoodsDia('priceList', index, item)"
                      :disabled="false"
                      >查看展示奖品</el-button
                    >
                  </div>
                </div>
                <div class="btnbox">
                  <div class="column-between" v-show="priceList.length != 1">
                    <el-button
                      type="danger"
                      size="mini"
                      style="margin-bottom: 25px"
                      @click="delItem('priceList', index)"
                      :disabled="item.disabled || disabledType == 3"
                      >删除</el-button
                    >
                    <el-button
                      plain
                      size="mini"
                      style="margin-bottom: 5px"
                      @click="changeSort('priceList', 1, index)"
                      v-if="index != 0"
                      :disabled="item.disabled || disabledType == 3"
                      >上移</el-button
                    >
                    <el-button
                      plain
                      size="mini"
                      @click="changeSort('priceList', 2, index)"
                      v-if="index != priceList.length - 1"
                      :disabled="item.disabled || disabledType == 3"
                      >下移</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <div
          v-if="disabledType != 3"
          style="margin-top: 50px; padding-left: 260px"
        >
          <el-button type="primary" style="width: 100px" @click="submitForm"
            >保 存</el-button
          >
          <!-- <el-button plain
                     style="width:100px">取 消</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import ImportExcel from "@/components/importExcel/index.vue";
import AddGoods from "./AddGoods.vue";
import marketing from "@/api/marketing.js";
import common from "@/api/common.js";

export default {
  components: {
    ImportExcel,
    AddGoods,
  },
  data() {
    const validateTime = (rule, value, callback) => {
      let newTime = dayjs(new Date()).format("YYYY-MM-DD");
      if (!value.length) {
        callback(new Error("请选择时间"));
      } else if (value[1] < newTime && this.$route.query.type != 3) {
        callback(new Error("结束时间至少大于等于当前日期"));
      } else {
        callback();
      }
    };
    return {
      interfaceName: "uploadExcleDoctorHeartPhone",
      info: {
        act_name: "",
        remark: "",
        act_time: "",
        act_url: "",
        doctor_auth: 1,
        doctor_string: "",
        rule_obj: "",
      },
      jd_options: [],
      rules: {
        act_name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        act_time: [
          { required: true, validator: validateTime, trigger: "change" },
        ],
        act_url: [
          { required: true, message: "请填写活动链接", trigger: "blur" },
        ],
        doctor_auth: [
          { required: true, message: "请选择活动参与医生", trigger: "blur" },
        ],
      },
      uploadExtraData: {
        img_type: 4,
        suffix: ".jpg",
      },
      priceList: [
        {
          rule_name: "",
          total_drug_price: "",
          heart_multiple: "",
          heart_num: "",
          sort: "",
          content: [], //奖励图片，多个逗号隔开
          jd_access_key: "",
          jd_public_key: "",
          jd_private_key: "",
        },
      ],
      isImport: false,
      isAddgoods: false,
      listName: "",
      index: "",
      imgList: [],
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    doctor_length() {
      if (this.info.doctor_string) {
        let arr = this.info.doctor_string.split(",");
        return arr.length;
      } else {
        return 0;
      }
    },
    disabledType() {
      // 1:add 2:edit 3:look 4:edit(未开始)
      return this.$route.query.type;
    },
    pageTitle() {
      switch (Number(this.$route.query.type)) {
        case 1:
          return "新增活动";
        case 2:
          return "编辑活动";
        case 3:
          return "查看活动";
        case 4:
          return "编辑活动";
      }
    },
  },
  created() {
    if (
      this.$route.query.type == 2 ||
      this.$route.query.type == 3 ||
      this.$route.query.type == 4
    ) {
      this.getDoctorHeartActivity();
    }
    this.getJdShopConfig();
  },
  methods: {
    // 京东兑换配置
    async getJdShopConfig() {
      let { data } = await common.getJdShopConfig();
      this.jd_options = data.value;
    },
    // 回显
    getDoctorHeartActivity() {
      let params = {
        act_id: this.$route.query.act_id,
      };
      const loading = this.$loading();
      marketing
        .getDoctorHeartActivity(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.info = data.activity_info;
            this.info.act_time = [
              dayjs.unix(this.info.start_time).format("YYYY-MM-DD"),
              dayjs.unix(this.info.end_time).format("YYYY-MM-DD"),
            ];
            if (this.disabledType == 2) {
              this.priceList = data.rule_info.map((item) => {
                item.disabled = true;
                return item;
              });
            } else {
              this.priceList = data.rule_info;
            }
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    handleTextareaKeydown() {
      let e = window.event || arguments[0];
      if (e.key === "Enter" || e.code === "Enter" || e.keyCode == 13) {
        e.returnValue = false;
        return false;
      }
    },
    // 礼品兑换专区
    changeJdKey(item) {
      let { jd_access_key } = item;
      for (let jdItem of this.jd_options) {
        if (jdItem.jd_access_key === jd_access_key) {
          item.jd_public_key = jdItem.jd_public_key;
          item.jd_private_key = jdItem.jd_private_key;
          return;
        }
      }
    },
    //提交添加
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = this.info;
          if (params.doctor_auth == 2 && !params.doctor_string) {
            this.$message.error("请填写指定医生手机号");
            return false;
          }
          params.start_time = params.act_time[0];
          params.end_time = params.act_time[1];
          let isName = this.priceList.every((item) => {
            return item.rule_name != "";
          });

          let isTotal_drug_price = this.priceList.every((item) => {
            return item.total_drug_price > 0;
          });

          let isHeart_multiple = this.priceList.every((item) => {
            return item.heart_multiple > 0;
          });

          let isJd = this.priceList.every((item) => {
            return item.jd_access_key != "";
          });

          if (!isName || !isTotal_drug_price || !isHeart_multiple || !isJd) {
            this.$message.error("请完善活动奖励规则");
            return false;
          }

          params.rule_obj = this.priceList.map((item, index) => {
            item.sort = index;
            return item;
          });
          let interfaceName = "saveDoctorHeartActivity";
          if (this.disabledType == 2 || this.disabledType == 4) {
            interfaceName = "updateDoctorHeartActivity";
          } else {
            interfaceName = "saveDoctorHeartActivity";
          }
          console.log("参数", params);
          marketing[interfaceName](params).then((res) => {
            if (res.code == 0) {
              this.$message.success("保存成功");
              this.back();
            }
          });
        }
      });
    },
    //导入数据
    addPhoneData() {
      this.isImport = !this.isImport;
    },
    //获取医生电话
    getPhoneData(code_array) {
      if (this.info.doctor_string) {
        let string = this.info.doctor_string.split(",");
        let arr = string.concat(code_array);
        if (this.disabledType == 2) {
          switch (this.info.doctor_auth) {
            case 2:
              if (arr.length <= string.length) {
                this.$message.error("只能添加医生");
              }
              return;
            case 3:
              if (arr.length > string.length) {
                this.$message.error("只能删除医生");
              }
              return;
          }
        }
        this.info.doctor_string = arr.toString();
      } else {
        this.info.doctor_string = code_array.toString();
      }
    },
    //增加节点
    addItem() {
      let data = {
        rule_name: "",
        total_drug_price: "",
        heart_multiple: "",
        heart_num: "",
        sort: "",
        content: [],
        disabled: false,
        jd_access_key: "",
        jd_public_key: "",
        jd_private_key: "",
      };
      this.priceList.push(data);
    },
    changeSort(list, type, index) {
      let data = this[list][index];
      this[list].splice(index, 1);
      //上移
      if (type == 1) {
        this[list].splice(index - 1, 0, data);
      }
      //下移
      if (type == 2) {
        this[list].splice(index + 1, 0, data);
      }
    },
    //删除节点
    delItem(list, index) {
      if (this[list].length === 1) {
        return;
      }
      this[list].splice(index, 1);
    },
    //编辑物品弹窗
    addGoodsDia(listName, index, item) {
      console.log(item);
      if (item.content && item.img_str) {
        let picArr = item.content.split(",");
        this.imgList = item.img_str.map((item, i) => {
          let obj = {
            path: item,
            pic: picArr[i],
          };
          return obj;
        });
      } else {
        this.imgList = [];
      }
      this.listName = listName;
      this.index = index;
      this.isAddgoods = !this.isAddgoods;
    },
    //获取奖励物品
    getGoods(imageInfo) {
      this.$set(
        this[this.listName][this.index],
        "content",
        imageInfo.picList.join(",")
      );
      this.$set(
        this[this.listName][this.index],
        "img_str",
        imageInfo.imageList
      );
    },
    back() {
      history.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 16px;
}
.box {
  position: relative;
  padding-left: 120px;
  box-sizing: border-box;
  margin-top: -20px;
  &:hover .shadow {
    display: flex;
  }
  .img {
    width: 200px;
    height: 200px;
  }
  .shadow {
    box-sizing: border-box;
    position: absolute;
    left: 120px;
    top: 0;
    width: 200px;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.6);
    display: none;
  }
  i + i {
    margin-left: 30px;
    color: #d44747;
  }
  i {
    color: #ffffff;
    font-size: 30px;
    text-align: center;
    cursor: pointer;
  }
}
.checkbox {
  padding: 20px 30px;
  margin-right: 50px;
  border-radius: 10px;
  cursor: pointer;
  .big_word {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
}
.list_item {
  padding: 20px;
  background: #f5f5f5;
  width: 700px;
  border-radius: 10px;
  margin-bottom: 14px;
  .item_title {
    display: inline-block;
    width: 100px;
    font-weight: 700;
  }
}
.reward_img {
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  margin-bottom: 10px;
  background-color: #fff;
  border: solid 1px #d6d6d6;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .avatar {
    width: 100px;
    height: 100px;
  }
  .uploader-icon {
    font-size: 30px;
    color: #d6d6d6;
  }
}
</style>
<style>
.btnbox .el-button + .el-button {
  margin-left: 0px;
}
</style>
